"use client";

import { motion } from "framer-motion";
import { Star, ExternalLink } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { REVIEWS } from "@/lib/constants";

export function ReviewsSection() {
  return (
    <section id="reviews" className="section-padding bg-card/30">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="text-sm font-medium uppercase tracking-[0.2em] text-primary">
            Testimonials
          </p>
          <h2 className="mt-3 font-playfair text-3xl font-bold text-foreground md:text-4xl lg:text-5xl">
            What Our Guests Say
          </h2>
        </motion.div>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:gap-8">
          {REVIEWS.map((review, i) => (
            <motion.div
              key={review.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="group rounded-xl border border-border bg-card/80 p-6 transition-all hover:border-primary/20 hover:shadow-lg hover:shadow-primary/5 md:p-8"
            >
              {/* Stars */}
              <div className="flex gap-1">
                {Array.from({ length: review.rating }, (_, j) => (
                  <Star
                    key={j}
                    className="size-4 fill-primary text-primary"
                  />
                ))}
              </div>

              {/* Quote */}
              <p className="mt-4 text-base leading-relaxed text-foreground/90 italic">
                &ldquo;{review.text}&rdquo;
              </p>

              {/* Reviewer */}
              <div className="mt-6 flex items-center justify-between">
                <div>
                  <p className="font-semibold text-foreground">
                    {review.name}
                  </p>
                  <p className="text-sm text-muted-foreground">{review.date}</p>
                </div>
                <Badge
                  variant="secondary"
                  className="gap-1 capitalize"
                >
                  {review.source === "airbnb" ? (
                    <ExternalLink className="size-3" />
                  ) : null}
                  {review.source}
                </Badge>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
